import { useState } from 'react'
import { Image01Icon } from './icons'
import { Skeleton } from './skeleton'

interface ImagePreviewProps {
	src?: string
	alt: string
	className?: string
	imageProps?: React.ImgHTMLAttributes<HTMLImageElement>
	width?: number | string
	height?: number | string
}

function ImagePreview({
	src,
	alt,
	className,
	width,
	height
}: ImagePreviewProps) {
	const [imageState, setImageState] = useState<
		'loading' | 'loaded' | 'error'
	>('loading')

	if (imageState === 'error' || !src) {
		return (
			<div className='flex aspect-square h-full w-full items-center justify-center bg-neutral-200'>
				<Image01Icon />
			</div>
		)
	}

	return (
		<>
			{/* biome-ignore lint/a11y/noNoninteractiveElementInteractions: onLoad/onError are media lifecycle events, not interactive handlers */}
			<img
				alt={alt}
				className={className}
				height={height}
				hidden={imageState === 'loading'}
				onError={() => setImageState('error')}
				onLoad={() => setImageState('loaded')}
				src={src}
				width={width}
			/>

			{imageState === 'loading' ? (
				<Skeleton className={className} />
			) : null}
		</>
	)
}

export { ImagePreview }
